import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { ForumComponent } from './forum/forum.component';
import { MarketplacePageComponent } from './marketplace/marketplace.component';
import { MarketplaceShopDetailComponent } from './marketplace/shop-detail/marketplace-shop-detail.component';
import { NewsComponent } from './news/news.component';
import { SingleNewComponent } from './news/single-new/single-new.component';
import { CustomersLayoutComponent } from './layout/customers-layout/customers-layout.component';
import { CustomersLayoutReferralComponent } from './layout/customers-layout-referral/customers-layout-referral.component';
import { RolesComponent } from './community/roles/roles.component';
import { GiveawayComponent } from './forum/giveaway/giveaway.component';
import { PollComponent } from './forum/poll/poll.component';
import { TabForumComponent } from './forum/tab-forum/tab-forum.component';
import { MemberPageComponent } from './community/member-page/member-page.component';
import { CommunitySearchComponent } from './community/community-search/community-search.component';
import { CommunityProfileComponent } from './community/profile/profile.component';
import { SearchComponent } from './community/search/search.component';
import { NewsMeComponent } from './community/member-page/me/news-me/news-me.component';
import { ProfileMeComponent } from './community/member-page/me/profile-me/profile-me.component';
import { AddMeComponent } from './community/member-page/me/add-me/add-me.component';
import { NearbyproductsMeComponent } from './community/member-page/me/nearbyproducts-me/nearbyproducts-me.component';
import { IndividualRentalComponent } from './community/member-page/me/nearbyproducts-me/individual-rental/individual-rental.component';
import { IndividualAllProductComponent } from './community/member-page/me/nearbyproducts-me/individual-all-product/individual-all-product.component';
import { IndividualFreeComponent } from './community/member-page/me/nearbyproducts-me/individual-free/individual-free.component';
import { IndividualServicesComponent } from './community/member-page/me/nearbyproducts-me/individual-services/individual-services.component';
import { IndividualEventsComponent } from './community/member-page/me/nearbyproducts-me/individual-events/individual-events.component';
import { OtherCommuntyPageComponent } from './community/other-communty-page/other-communty-page.component';
import { SellComponent } from './community/other-communty-page/sell/sell.component';
import { BuyComponent } from './community/other-communty-page/buy/buy.component';
import { ReferComponent } from './community/other-communty-page/refer/refer.component';
import { WriteArticlesComponent } from './community/other-communty-page/write-articles/write-articles.component';
import { ShopPageComponent } from './shop-page/shop-page.component';
import { HowToEarnComponent } from './community/other-communty-page/how-to-earn/how-to-earn.component';
import { TermsOfRentalComponent } from './community/other-communty-page/terms-of-rental/terms-of-rental.component';
import { TermsOfServiceComponent } from './community/other-communty-page/terms-of-service/terms-of-service.component';
import { CommunityRedirectGuard } from './util/guard/community-redirect-guard/community-redirect.guard';
import { canDeactivateModalGuard } from '../shareModule/guard/can-deactivate-modal.guard';
import { AroundeMeComponent } from './community/member-page/me/around-me/around-me.component';
import { AdvancedSettingsComponent } from './advanced-settings/advanced-settings.component';
import { FaqComponent } from './faq/faq.component';
import { AdvancedSettingsReferralComponent } from './advanced-settings-referral/advanced-settings-referral.component';
import { IndividualProductsResolver } from './community/member-page/member-page.resolver';
import { MarketplaceShopDetailResolver } from './marketplace/shop-detail/marketplace-shop-detail.resolver';
import { MarketplaceResolver } from './marketplace/marketplace.resolver';
import { PatchNoteComponent } from './customer-footer/patch-note/patch-note.component';
import { MarketplaceProductComponent } from './marketplace/marketplace-product/marketplace-product.component';
import { MarketplaceProductResolver } from './marketplace/marketplace-product/marketplace-product.resolver';
import { RecommendPageComponent } from './recommend-page/recommend-page.component';
import { HowItWorksComponent } from './how-it-works/how-it-works.component';
import { BizLayoutComponent } from './biz-layout/biz-layout.component';
import { SingleForumComponent } from './forum/tab-forum/single-forum/single-forum.component';
import { AdvancedSettingsIntroComponent } from './advanced-settings/advanced-settings-intro/advanced-settings-intro.component';
import { AdvancedSettingsProfileComponent } from './advanced-settings/advanced-settings-profile/advanced-settings-profile.component';
import { AdvancedSettingsContributionComponent } from './advanced-settings/advanced-settings-contribution/advanced-settings-contribution.component';
import { AdvancedSettingsPasswordComponent } from './advanced-settings/advanced-settings-password/advanced-settings-password.component';
import { AdvancedSettingsVerifyComponent } from './advanced-settings/advanced-settings-verify/advanced-settings-verify.component';
import { AdvancedSettingsPreferencesComponent } from './advanced-settings/advanced-settings-preferences/advanced-settings-preferences.component';
import { AdvancedSettingsTagsComponent } from './advanced-settings/advanced-settings-tags/advanced-settings-tags.component';
import { AdvancedSettingsSuperSellerComponent } from './advanced-settings/advanced-settings-super-seller/advanced-settings-super-seller.component';
import { AdvancedSettingsSuperSellerSettingsComponent } from './advanced-settings/advanced-settings-super-seller-settings/advanced-settings-super-seller-settings.component';
import { AdvancedSettingsChatComponent } from './advanced-settings/advanced-settings-chat/advanced-settings-chat.component';
import { AdvancedSettingsSeoComponent } from './advanced-settings/advanced-settings-seo/advanced-settings-seo.component';
import { AdvancedSettingsCheckoutHistoryComponent } from './advanced-settings/advanced-settings-checkout-history/advanced-settings-checkout-history.component';
import { NearbyMapComponent } from '../nearby-map/nearby-map.component';
import { WhatIsKachiingComponent } from './community/other-communty-page/what-is-kachiing/what-is-kachiing.component';
import { ManualReviewTaskComponent } from './community/search/manual-review-task/manual-review-task.component';
import { CommunityYoutubeComponent } from './community/community-youtube/community-youtube.component';
import { CommunityEatComponent } from './community/community-eat/community-eat.component';
import { CommunitySpecialTopicComponent } from './community/community-special-topic/community-special-topic.component';
import { MyPageAnimateComponent } from '../my-page-animate/my-page-animate.component';
import { MyNetworkComponent } from '../my-network/my-network.component';
import { AmchartsGaugeComponent } from '../amcharts-gauge/amcharts-gauge.component';
import { ProductShopComponent } from '../product-shop/product-shop.component';

const routes: Routes = [

  {
    path: 'map/:prefixedSlug',
    component: NearbyMapComponent,       
  },
  {
    path: 'map/:prefixedSlug/:viewMode',
    component: NearbyMapComponent
  },
  {
    path: 'map',
    component: NearbyMapComponent, //full page needs to be a map similar to sample
    //canActivate: [CommunityRedirectGuard],
 
  },
  {
    path: 'user-tasks/:user',
    component: ManualReviewTaskComponent,
  },
  {
    path: '',
    component: CustomersLayoutComponent,
    children: [
      { path: 'home/:base', component: CommunitySearchComponent },
      { path: 'home/:base/:category', component: CommunitySearchComponent },

      { path: 'patch-Note', component: PatchNoteComponent },
      { path: '', component: CommunitySearchComponent },
      {
        path: '',
        component: OtherCommuntyPageComponent,
        children: [
          { path: 'roles', component: RolesComponent },
          { path: 'how-to-earn', component: HowToEarnComponent },

          { path: 'buy', component: BuyComponent },
          { path: 'sell', component: SellComponent },
          { path: 'refer', component: ReferComponent },
          { path: 'write-articles', component: WriteArticlesComponent },

          { path: 'what-is-kachiing', component: WhatIsKachiingComponent },
        ],
      },
      { path: 'policies', component: TermsOfServiceComponent },
      { path: 'faq', component: FaqComponent },
      { path: 'youtube', component: CommunityYoutubeComponent },
      { path: 'eat', component: CommunityEatComponent },
      { path: 'special-topics', component: CommunitySpecialTopicComponent },
      {
        path: 'rental-system-terms-and-conditions',
        component: TermsOfRentalComponent,
      },
      {
        path: '',
        children: [
          { path: '', component: CommunitySearchComponent },

          { path: 'profile/:code', component: CommunityProfileComponent },

          {
            path: 'me',
            component: MemberPageComponent,
            // canActivate: [CommunityRedirectGuard],
            children: [
              {
                path: '',
                component: NearbyproductsMeComponent,
                canActivate: [CommunityRedirectGuard],
                children: [
                  { path: '', component: IndividualAllProductComponent },
                  {
                    path: 'nearby',
                    component: IndividualAllProductComponent,
                    // resolve: {
                    //   individualProducts: IndividualProductsResolver,
                    // },
                  },

                  {
                    path: 'nearby/:slug',
                    component: IndividualAllProductComponent,
                    resolve: {
                      individualProducts: IndividualProductsResolver,
                    },
                  },
                  { path: 'rental', component: IndividualRentalComponent },
                  { path: 'free', component: IndividualFreeComponent },
                  { path: 'events', component: IndividualEventsComponent },
                  { path: 'services', component: IndividualServicesComponent },
                  { path: 'recommend', component: RecommendPageComponent },
                ],
              },
              { path: 'around', component: AroundeMeComponent },
              { path: 'profile', component: ProfileMeComponent },
              { path: 'list', component: AddMeComponent },
              { path: 'shout-out', component: NewsMeComponent },
              // { path: ":base", component: CommunitySearchComponent },
              // { path: ":base/:category", component: CommunitySearchComponent },
              // { path: ":base/:category/:slug", component: CommunitySearchComponent },
            ],
          },
          {
            path: 'category/:categoryName',
            component: SearchComponent,
            // children: [
            //   {
            //     path: ':subregionName',
            //     component: SearchComponent,

            //   }
            // ]
          },
          {
            path: 'category/:categoryName/:slug',
            component: SearchComponent,
          },
          {
            path: 'category/:categoryName/:subCategoryName',
            component: SearchComponent,
          },
          {
            path: 'category/:categoryName/:subCategoryName/:slug',
            component: SearchComponent,
          },
          {
            path: 'rental/:categoryName',
            component: SearchComponent,
          },
          {
            path: 'rental/:categoryName/:slug',
            component: SearchComponent,
          },
          {
            path: 'rental/:categoryName/:subCategoryName',
            component: SearchComponent,
          },
          {
            path: 'rental/:categoryName/:subCategoryName/:slug',
            component: SearchComponent,
          },
        ],
      },
      {
        path: 'tasks',
        children: [
          {
            path: '',
            component: ManualReviewTaskComponent,
          },
        ],
      },
      {
        path: 'animate',
        children: [
          {
            path: '',
            component: MyPageAnimateComponent,
          },
        ],
      },
      {
        path: 'network',
        children: [
          {
            path: '',
            component: MyNetworkComponent,
          },
        ],
      },
      {
        path: 'charts-gauge',
        children: [
          {
            path: '',
            component: AmchartsGaugeComponent,
          },
        ],
      },
      {
        path: 'product',
        // component: MarketplaceProductComponent,

        children: [
          {
            path: ':product',
            component: MarketplaceProductComponent,
            // resolve: {
            //   MarketplaceProductResolver: MarketplaceProductResolver
            // },
          },
        ],
      },
      {
        path: '',
        children: [
          {
            path: '',
            component: ForumComponent,
            children: [
              { path: 'forum', component: TabForumComponent },
              { path: 'giveaway', component: GiveawayComponent },
              { path: 'poll', component: PollComponent },
            ],
          },
          { path: 'forum/:slug', component: SingleForumComponent },
          // { path: ":category", component: TabForumComponent },
          // { path: ":category/:uuid", component: TabForumComponent },
        ],
      },
      // { path: "chat", component: ChatPageComponent },
      {
        path: 'shop-page',
        component: ShopPageComponent,
        canActivate: [CommunityRedirectGuard],
      },
      {
        path: 'advanced-settings',
        component: AdvancedSettingsComponent,
        canActivate: [CommunityRedirectGuard],
        children: [
          { path: '', component: AdvancedSettingsIntroComponent },
          { path: 'profile', component: AdvancedSettingsProfileComponent },
          {
            path: 'contributions',
            component: AdvancedSettingsContributionComponent,
          },
          { path: 'password', component: AdvancedSettingsPasswordComponent },
          { path: 'verify', component: AdvancedSettingsVerifyComponent },
          {
            path: 'preferences',
            component: AdvancedSettingsPreferencesComponent,
          },
          { path: 'tags', component: AdvancedSettingsTagsComponent },
          {
            path: 'super-seller',
            component: AdvancedSettingsSuperSellerComponent,
          },
          {
            path: 'super-seller-settings',
            component: AdvancedSettingsSuperSellerSettingsComponent,
          },
          { path: 'chat', component: AdvancedSettingsChatComponent },
          { path: 'seo', component: AdvancedSettingsSeoComponent },
          {
            path: 'checkout-history',
            component: AdvancedSettingsCheckoutHistoryComponent,
          },
        ],
      },
      {
        path: 'rewards',
        component: MarketplaceShopDetailComponent,
        //canActivate: [CommunityRedirectGuard],
      },
      // {
      //   path: 'shop/:shop',
      //   component: MarketplaceShopDetailComponent,
      // },
      {
        path: 'biz',
        canDeactivate: [canDeactivateModalGuard],
        resolve: {
          MarketplaceResolver: MarketplaceResolver,
        },
        children: [
          {
            path: '',
            component: BizLayoutComponent,
            children: [
              {
                path: '',
                component: MarketplacePageComponent,
              },
              {
                path: 'how-it-works',
                component: HowItWorksComponent,
              },
            ],
          },
          // {
          //   path: 'shop/:shop',
          //   component: MarketplaceShopDetailComponent,
          //   resolve: { MarketplaceShopDetail: MarketplaceShopDetailResolver },
          // },
          {
            path: 'category/:category',
            component: MarketplacePageComponent,
          },
          {
            path: 'category/:category/:slug',
            component: MarketplacePageComponent,
          },
          {
            path: ':slug',
            component: MarketplacePageComponent,
          },
        ],
      },
      {
        path: 'news',
        component: NewsComponent,
      },
      { path: 'news/:slug', component: SingleNewComponent },
      { path: 'privacy', component: PrivacyPolicyComponent },
      { path: 'contact-us', component: ContactUsComponent },
      {
        path: '',
        children: [
          //search Page route
          {
            path: 'category/:categoryName',
            component: SearchComponent,
          },
          {
            path: 'category/:categoryName/:slug',
            component: SearchComponent,
          },
          {
            path: 'category/:categoryName/:subCategoryName',
            component: SearchComponent,
          },
          {
            path: 'category/:categoryName/:subCategoryName/:slug',
            component: SearchComponent,
          },
          {
            path: 'rental/:categoryName',
            component: SearchComponent,
          },
          {
            path: 'rental/:categoryName/:slug',
            component: SearchComponent,
          },
          {
            path: 'rental/:categoryName/:subCategoryName',
            component: SearchComponent,
          },
          {
            path: 'rental/:categoryName/:subCategoryName/:slug',
            component: SearchComponent,
          },
          // { path: ':base', component: CommunitySearchComponent },
          // { path: ':base/:category', component: CommunitySearchComponent },
          // {
          //   path: ':base/:category/:slug',
          //   component: CommunitySearchComponent,
          // },
          //search Page route
        ],
      },
      { path: 'shop/:shop', component: ProductShopComponent },
      { path: '', redirectTo: '/', pathMatch: 'full' },
    ],
  },
  {
    path: 'profile/:code',
    component: CustomersLayoutComponent,
    children: [
      {
        path: '',
        component: CommunityProfileComponent,
      },
    ],
  },
  {
    path: 'brand',
    component: CustomersLayoutReferralComponent,
    children: [
      { path: '', component: MarketplaceShopDetailComponent },
      { path: 'settings', component: AdvancedSettingsReferralComponent },
    ],
  },
  {
    path: 'share/:shop',
    component: CustomersLayoutReferralComponent,
    children: [
      {
        path: '',
        component: MarketplaceShopDetailComponent,
        resolve: { MarketplaceShopDetail: MarketplaceShopDetailResolver },
      },
      { path: 'settings', component: AdvancedSettingsReferralComponent },
    ],
  },

  { path: '**', redirectTo: '/' },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CustomersRoutingModule { }
